import { render, staticRenderFns } from "./Bara.vue?vue&type=template&id=e3cbfea2&"
import script from "./Bara.vue?vue&type=script&lang=js&"
export * from "./Bara.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports